import React from "react";
import { useAuth } from "../../Auth/AuthContext";
import NavBar from "./NavBar";

const MainNavBar = (props) => {
    const {parentMenu} = props;
    const { userRole } = useAuth();
    const isAdmin = userRole === "admin" || userRole === "superadmin";

    return (
        <NavBar isAdmin={isAdmin} isLoggedIn={Boolean(userRole)} parentMenu={parentMenu} />
    )
};

export default MainNavBar;

